import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import type { Option } from './Navbar'

const MoreSlider: React.FC<{
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  menuItems: Option[]
}> = ({ open, setOpen, menuItems }) => {
  const options: Option[] = menuItems

  const buttonClass =
    'my-4 flex items-center rounded-md border border-text-primary p-4 text-base font-semibold text-text-primary'

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-background-overlay transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-28">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4"></div>
                  </Transition.Child>
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    <div className="flex justify-between px-4 sm:px-6">
                      <Dialog.Title className="text-lg font-semibold text-text-primary">
                        More
                      </Dialog.Title>
                      <button
                        type="button"
                        className="text-text-primary"
                        onClick={() => setOpen(false)}
                      >
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                      <div className="absolute inset-0 px-4 sm:px-6">
                        {options.map((obj: Option) => (
                          <Fragment key={obj.id}>
                            {obj.handleOnClick ? (
                              <button
                                onClick={() => obj.handleOnClick()}
                                className={`${buttonClass} w-full`}
                              >
                                {obj.iconSvg ? (
                                  <img
                                    src={obj.iconSvg}
                                    className="object-cove4 mr-3 w-5"
                                    alt="icon"
                                  />
                                ) : (
                                  obj.icon
                                )}
                                <p className="font-normal">{obj.text}</p>
                              </button>
                            ) : (
                              <Link
                                to={obj.to}
                                onClick={() => setOpen(false)}
                                className={buttonClass}
                              >
                                {obj.iconSvg ? (
                                  <img
                                    src={obj.iconSvg}
                                    className="object-cove4 mr-3 w-5"
                                    alt="icon"
                                  />
                                ) : (
                                  obj.icon
                                )}
                                <p className="font-normal">{obj.text}</p>
                              </Link>
                            )}
                          </Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default MoreSlider
